import React from 'react';
import cx from 'classnames';

import { safeMap } from '@src/utils/mapper';

import { CustomSlider } from '@commons/custom-slider/CustomSlider';

import * as styles from './testimonial-slider.module.scss';

export const Testimonial = ({ quote, author, company, logo, logoAlt, customClasses = '' }) => {
  return (
    <div className={styles.singleTestimonial}>
      <q className={styles.quote}>{quote}</q>
      <p className={styles.author}>{author}</p>
      {company && <p>{company}</p>}
      {logo && (
        <img
          loading="lazy"
          src={logo}
          alt={logoAlt}
          className={cx(styles.logo, customClasses)}
          width="250"
          height="50"
        />
      )}
    </div>
  );
};

export const TestimonialSlider = ({ testimonials, className }) => {
  return (
    <CustomSlider className={className}>
      {safeMap(testimonials, (quotation, index) => (
        <Testimonial key={index} {...quotation} />
      ))}
    </CustomSlider>
  );
};
